import { WithSubpages } from '../../subpages';
import { smsSubpages } from '../../subpages/dictionary';
import { PAGE_TITLE } from '../../consts';

import { MAIN_PAGE_PATH } from './paths';

const SMS = () => <WithSubpages mainPagePath={MAIN_PAGE_PATH} title={PAGE_TITLE.SMS} items={smsSubpages} />;

export default SMS;
